import { render, staticRenderFns } from "./customercouponlist.vue?vue&type=template&id=8d30dfa2&scoped=true"
import script from "./customercouponlist.vue?vue&type=script&lang=js"
export * from "./customercouponlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d30dfa2",
  null
  
)

export default component.exports